import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import PdfViewer from './components/PdfViewer/PdfViewer';

const AppRoutes = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path='/' element={<PdfViewer />} />
            </Routes>
        </BrowserRouter>
    );
}

export default AppRoutes;